import React, { useEffect } from "react";
import { Link, useParams, Navigate } from "react-router-dom";
import { path } from "./therapyPaths";
import TherapyNav from "./TherapyNav";
import TherapyFooter from "./TherapyFooter";
import { Icon } from "./Icons";
import TherapistPortrait from "./TherapistPortrait";
import { findTherapist } from "./therapists";
import "./Therapy.css";
import "./TherapyPages.css";
import "./Therapists.css";

function TherapyTherapistProfile() {
    const { slug } = useParams();
    const therapist = findTherapist(slug);

    useEffect(() => {
        window.scrollTo(0, 0);
    }, [slug]);

    if (!therapist) {
        return <Navigate to={path("therapists")} replace />;
    }

    return (
        <main className="demo demo-therapy">
            <TherapyNav />

            <section className="page-header">
                <div className="demo-container">
                    <Link to={path("therapists")} className="breadcrumb-link">
                        ← All therapists
                    </Link>
                </div>
            </section>

            <section className="demo-section therapist-profile-hero">
                <div className="demo-container therapist-profile-grid">
                    <aside className="therapist-profile-aside">
                        <div className="profile-portrait">
                            <TherapistPortrait therapist={therapist} size="profile" />
                        </div>
                        <div className="profile-meta">
                            <div className="profile-meta-row">
                                <span className="profile-meta-label">Pronouns</span>
                                <span className="profile-meta-value">{therapist.pronouns}</span>
                            </div>
                            <div className="profile-meta-row">
                                <span className="profile-meta-label">Languages</span>
                                <span className="profile-meta-value">{therapist.languages.join(", ")}</span>
                            </div>
                            <div className="profile-meta-row">
                                <span className="profile-meta-label">In practice</span>
                                <span className="profile-meta-value">{therapist.yearsInPractice} years</span>
                            </div>
                            <div className="profile-meta-row">
                                <span className="profile-meta-label">Individual fee</span>
                                <span className="profile-meta-value">${therapist.fee} / 50 min</span>
                            </div>
                            {therapist.offersCouples && (
                                <div className="profile-meta-row">
                                    <span className="profile-meta-label">Couples fee</span>
                                    <span className="profile-meta-value">${therapist.coupleFee} / 60 min</span>
                                </div>
                            )}
                        </div>

                        <Link
                            to={path(`book/${therapist.slug}`)}
                            className="btn-primary profile-book-btn"
                        >
                            Book with {therapist.name.split(" ").slice(-1)[0]}
                        </Link>
                        <Link
                            to={path("booking")}
                            className="btn-secondary profile-consult-btn"
                        >
                            Free consultation first
                        </Link>

                        <div className="profile-availability">
                            <Icon name="clock" size={14} />
                            <p>{therapist.availabilityNote}</p>
                        </div>
                    </aside>

                    <div className="therapist-profile-content">
                        <p className="demo-eyebrow">{therapist.credential}</p>
                        <h1>{therapist.name}</h1>
                        <p className="therapist-profile-tagline">{therapist.bioShort}</p>

                        <div className="profile-section">
                            <h2>About</h2>
                            {therapist.bioLong.map((p, i) => (
                                <p key={i}>{p}</p>
                            ))}
                        </div>

                        <div className="profile-section">
                            <h2>Specializations</h2>
                            <div className="profile-tag-grid">
                                {therapist.specializations.map((spec) => (
                                    <span key={spec} className="profile-tag profile-tag-primary">
                                        {spec}
                                    </span>
                                ))}
                            </div>
                        </div>

                        <div className="profile-section">
                            <h2>Approach &amp; methods</h2>
                            <div className="profile-tag-grid">
                                {therapist.modalities.map((m) => (
                                    <span key={m} className="profile-tag">
                                        {m}
                                    </span>
                                ))}
                            </div>
                        </div>

                        <div className="profile-section">
                            <h2>Populations I work with</h2>
                            <ul className="profile-list">
                                {therapist.populations.map((pop) => (
                                    <li key={pop}>
                                        <Icon name="check" size={16} />
                                        <span>{pop}</span>
                                    </li>
                                ))}
                            </ul>
                        </div>

                        <div className="profile-section">
                            <h2>Training &amp; credentials</h2>
                            <div className="profile-credentials">
                                {therapist.education.map((ed, i) => (
                                    <div key={i} className="profile-credential-row">
                                        <span className="profile-credential-year">{ed.year}</span>
                                        <span className="profile-credential-label">{ed.label}</span>
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <section className="demo-section demo-cta">
                <div className="demo-container">
                    <h2>Ready to book?</h2>
                    <p>
                        Book directly with {therapist.name.split(" ").slice(-1)[0]} or
                        start with a free consultation if you want to feel things out
                        first.
                    </p>
                    <div className="demo-actions demo-actions-center">
                        <Link
                            to={path(`book/${therapist.slug}`)}
                            className="btn-primary"
                        >
                            Book with {therapist.name.split(" ").slice(-1)[0]}
                        </Link>
                        <Link to={path("booking")} className="btn-secondary">
                            Free consultation
                        </Link>
                    </div>
                </div>
            </section>

            <TherapyFooter />
        </main>
    );
}

export default TherapyTherapistProfile;